import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import ExcelJS from 'exceljs'

interface Data {
  id: number
  deviceId: number
  topicId: number
  payload: string
  device: null
  smrTopic: null
  createdUserId: number
  createDate: string
  updateDate: null
  deleteDate: null
  isActive: boolean
  isDelete: boolean
}

function Message({message, measurementUnit, title}: any) {
  let newMessageData = message
    .sort((a: Data, b: Data) => new Date(a.createDate).getTime() - new Date(b.createDate).getTime())
    .reverse()

  const lang = useLang()

  function getDate(createDate: Date) {
    const date = new Date(createDate)
    const formattedDate = new Intl.DateTimeFormat(lang === 'tr' ? 'tr-TR' : 'en-EN', {
      dateStyle: 'full',
      timeStyle: 'medium',
    }).format(date)

    return formattedDate
  }

  function getDay(createDate: string) {
    const date = new Date(createDate)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }

  function getHour(createDate: string) {
    const date = new Date(createDate)
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${hours}:${minutes}:${seconds}`
  }

  async function exportToExcel() {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('SenseMiner')

    // Tabloyu oluşturun ve veri ekleyin
    worksheet.columns = [
      {header: 'Create Day', key: 'CreateDay', width: 15, style: {numFmt: 'dd/mm/yyyy'}},
      {header: 'Create Hour', key: 'CreateHour', width: 15, style: {numFmt: 'hh:mm'}},
      {
        header: 'Value',
        key: 'Value',
        width: 10,
        style: typeof tableData[0].Value != 'string' ? {numFmt: '0.00'} : {numFmt: ''},
      },
      {header: 'Measurement Unit', key: 'MeasurementUnit', width: 25},
    ]

    // Tablonun stilini ayarlayın
    worksheet.getRow(1).font = {bold: true}
    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'E8F7F5'},
      }
      cell.border = {
        top: {style: 'thin'},
        left: {style: 'thin'},
        bottom: {style: 'thin'},
        right: {style: 'thin'},
      }
    })

    tableData.forEach((item: any) => {
      worksheet.addRow({
        CreateDay: item.CreateDay,
        CreateHour: item.CreateHour,
        Value: item.Value,
        MeasurementUnit: item.MeasurementUnit,
      })
    })

    // Kenarlık ekle
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          }
        })
      }
    })

    // Sütun genişliklerini otomatik olarak ayarla
    worksheet.columns.forEach((column: any) => {
      column.width = Math.max(column.width, 10)
    })

    // Excel dosyasını oluşturun ve indirin
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = `${title}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  }

  //Excel İçin Veri Oluştur
  const tableData = newMessageData.map((item: any) => {
    function correctedText(data: any) {
      return `x: ${data[0]}   y: ${data[1]}   z: ${data[2]}`
    }
    let value
    let payloadType = JSON.parse(item.payload).type
    if (payloadType === 'DATA_ACCELERATION' || payloadType === 'DATA_GYRO') {
      // İstenen işlemi yap
      value = correctedText(JSON.parse(item.payload).value)
    } else {
      value = parseFloat(JSON.parse(item.payload).value)
    }

    return {
      CreateDay: getDay(item.createDate),
      CreateHour: getHour(item.createDate),
      Value: value,
      MeasurementUnit: `${measurementUnit[0]?.measurementUnit || ''}`,
    }
  })

  const MessageItem = newMessageData.map((item: any) => {
    function correctedText(data: any) {
      return `x: ${data[0]}   y: ${data[1]}   z: ${data[2]}`
    }
    let value
    let payloadType = JSON.parse(item.payload).type
    if (payloadType === 'DATA_ACCELERATION' || payloadType === 'DATA_GYRO') {
      // İstenen işlemi yap
      value = correctedText(JSON.parse(item.payload).value)
    } else {
      value = parseFloat(JSON.parse(item.payload).value)
    }

    return (
      <tr key={item.id} className='fs-6'>
        <td className='text-center'>{getDate(item.createDate)}</td>
        <td className='text-center text-success fw-bold fs-4'>
          {value} {measurementUnit[0]?.measurementUnit}
        </td>
        {tableData.length > 0 && <td></td>}
      </tr>
    )
  })

  return (
    <div className='table-responsive border rounded border-success  mt-5 '>
      <table className='table table-striped table-hover p-5 '>
        <thead style={{backgroundColor: '#E8F7F5'}}>
          <tr className='fw-bold fs-4 text-gray-800 border-bottom border-gray-200'>
            <th className='text-center w-50'>
              {lang === 'tr' ? 'Oluşturma Tarihi' : 'Create Date'}
            </th>
            <th className='text-center w-50'>{lang === 'tr' ? 'Değer' : 'Payload'}</th>
            {tableData.length > 0 && (
              <th className='text-center'>
                <button
                  type='button'
                  className='btn btn-success square border border-white btn-sm me-2'
                  onClick={exportToExcel}
                  title='Export Excel'
                >
                  <i className='bi bi-filetype-xlsx fs-2 text-white' />
                </button>
              </th>
            )}
          </tr>
        </thead>
        <tbody style={{backgroundColor: 'white'}}>{MessageItem}</tbody>
      </table>
    </div>
  )
}

export default Message
